import React, { useEffect, useState } from "react";
import PageWrapper from "../../../components/pageComponents/PageWrapper";
import PageHeader from "../../../components/pageHeader/PageHeader";
import SearchContainer from "../../../components/pageComponents/SearchContainer";
import PageButtons from "../../../components/pageComponents/PageButtons";
import styled from "styled-components";
import TableCampanaBonoTutoria from "./TableCampanasBonoTutoria";
import CrearCampanaBonoTutoria from "../modales/Campanas/CrearCampanaBonoTutoria";
import ModalEnabled from "../../../components/modalComponents/ModalEnabled";
import { getCampanasBonoTutoriaAPI } from "../../../consumers/backendApisUrls";
import { useManageGetRequest } from "../../../hooks/useManageGetRequest/useManageGetRequest";
import { useManagePostRequest } from "../../../hooks/useManagePostRequest/useManagePostRequest";

const AdminListarCampanasBonoTutoria = () => {
    const [formValues, setFormValues] = useState({
        Items: [],
        ExtraData: {},
        filters: [],
        selectedFilters: {},
      });
    const [searchCriteria, setSearchCriteria] = useState("");
    const [paginator, setPaginator] = useState({ CurrentPage: 1 });
    const [isLoading, setIsLoading] = useState(true);
    const [executeManagePost] = useManagePostRequest();
    const [modalEnabled, setModalEnabled] = useState({
        isEnable: false,
        component: React.Fragment,
    });
    const INIT_KEYS = {
        NombreCampana: "NombreCampana",
        FechaInicioCampana: "FechaInicioCampana",
        FechaFinCampana: "FechaFinCampana",
        FechaInicioTutoria: "FechaInicioTutoria",
        FechaFinTutoria: "FechaFinTutoria",
        LineamientoFile: "LineamientoFile",
        IdEmpleado: "IdEmpleado",
        FechaTutorInicio: "FechaTutorInicio",
        FechaTutorFin: "FechaTutorFin",
        EstadoRegistro: "EstadoRegistro",
        MontoProporcional: "MontoProporcional"
    };
    
    const init = async () => {
        setIsLoading(true);
        try {
            
        console.log("Metodo")
            await manageSearch();
        } catch (error) {
            console.error(error);
        } finally {
            setIsLoading(false);
        }
    };
    
    const manageSearch = async () => {
        setIsLoading(true);
        const api = getCampanasBonoTutoriaAPI();
        const payload = getPayload();
        try {
            await executeManagePost(api, payload, successManageSearchCallback);
        }
        catch (error) {
            console.log(error);
        }
        finally {
            setIsLoading(false);
        }
    };

    const handleCleanSearch = () => {
        setFormValues({ ...formValues, selectedFilters: {} });
    }

    const getPayload = () => {
        return {
            Criteria: searchCriteria,
            Page: paginator.CurrentPage,
            ...formValues.selectedFilters
        };
    };
    
    const handleNuevo = async () => {
    }
    const successPostCallback = () => {
        manageSearch();
    }

    const successManageSearchCallback = ({ data }) => {
        const {
            Items,
            ExtraData,
            TotalItems,
            FirsItemPage,
            LastItemPage,
            TotalPages,
            CurrentPage
        } = data;
        console.log(Items)
        const updateItems = Items.map((o) => {
            return {
                ...o,
            };
        });
        setFormValues((lastData) => ({
            ...lastData,
            Items: updateItems,
            ExtraData
        }));
        setPaginator({
            TotalItems,
            FirsItemPage,
            LastItemPage,
            TotalPages,
            CurrentPage,
        });
    };
    

    useEffect(() => {
        
        console.log("Metodo");
        init();
    }, []);

    return (
        <PageWrapper isLoading={isLoading}>
            <ModalEnabled
                modalEnabled={modalEnabled}
                setModalEnabled={setModalEnabled}
                refreshPage={manageSearch}
            />
            <PageHeader title="Lista de Campañas Bono Tutoria" />
            <SearchContainer
                searchCriteria={searchCriteria}
                setSearchCriteria={setSearchCriteria}
                setPaginator={setPaginator}
                manageSearch={manageSearch}
                addCleanSearch={handleCleanSearch}>
                <ButtonsWrapper>
                    <PageButtons hasBackButton
                        hasCreateButton
                        handleCreateButton={() =>
                            setModalEnabled({ isEnable: true, component: CrearCampanaBonoTutoria })
                        }
                    />
                </ButtonsWrapper>
            </SearchContainer>

            <TableCampanaBonoTutoria
                formValues={formValues}
                setFormValues={setFormValues}
                setModalEnabled={setModalEnabled}
                paginator={paginator}
                setPaginator={setPaginator}
                keys={INIT_KEYS}
                
            />
        </PageWrapper>
    );
}
export default AdminListarCampanasBonoTutoria;
const ButtonsWrapper = styled.div`
    display: block;
    @media (max-width: 796px) {
        display: none;
    }
`;